import { render, staticRenderFns } from "./PanelContainer.vue?vue&type=template&id=2bd35a6d&scoped=true&lang=pug&"
import script from "./PanelContainer.vue?vue&type=script&lang=js&"
export * from "./PanelContainer.vue?vue&type=script&lang=js&"
import style0 from "./PanelContainer.vue?vue&type=style&index=0&id=2bd35a6d&scoped=true&lang=css&"
import style1 from "./PanelContainer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../.yarn/$$virtual/vue-loader-virtual-5d68b12ba1/0/cache/vue-loader-npm-15.9.0-dfd6801660-2.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd35a6d",
  null
  
)

export default component.exports